// Utilitários de áudio para o PhoneDialer

// Frequências DTMF (Dual-Tone Multi-Frequency)
const DTMF_FREQUENCIES = {
  '1': { low: 697, high: 1209 },
  '2': { low: 697, high: 1336 },
  '3': { low: 697, high: 1477 },
  '4': { low: 770, high: 1209 },
  '5': { low: 770, high: 1336 },
  '6': { low: 770, high: 1477 },
  '7': { low: 852, high: 1209 },
  '8': { low: 852, high: 1336 },
  '9': { low: 852, high: 1477 },
  '*': { low: 941, high: 1209 },
  '0': { low: 941, high: 1336 },
  '#': { low: 941, high: 1477 },
};

let audioContext = null;

// Inicializar AudioContext
const getAudioContext = () => {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
  return audioContext;
};

// Tocar tom DTMF
export const playDTMFTone = (digit) => {
  try {
    const ctx = getAudioContext();
    const frequencies = DTMF_FREQUENCIES[digit];
    
    if (!frequencies) {
      return; // Dígito não suportado
    }

    const duration = 0.1; // 100ms
    const sampleRate = ctx.sampleRate;
    const frameCount = sampleRate * duration;
    
    const buffer = ctx.createBuffer(1, frameCount, sampleRate);
    const channelData = buffer.getChannelData(0);
    
    // Gerar onda senoidal para cada frequência
    for (let i = 0; i < frameCount; i++) {
      const t = i / sampleRate;
      const lowWave = Math.sin(2 * Math.PI * frequencies.low * t);
      const highWave = Math.sin(2 * Math.PI * frequencies.high * t);
      channelData[i] = (lowWave + highWave) / 2;
    }
    
    const source = ctx.createBufferSource();
    source.buffer = buffer;
    source.connect(ctx.destination);
    source.start(0);
    source.stop(ctx.currentTime + duration);
  } catch (error) {
    console.error('Erro ao tocar tom DTMF:', error);
  }
};

// Tocar ringtone (tom de chamada)
let ringtoneInterval = null;
let ringtoneAudio = null;

export const playRingtone = () => {
  stopRingtone(); // Parar qualquer ringtone anterior
  
  try {
    const ctx = getAudioContext();
    const ringFrequency = 440; // Lá (A4)
    const duration = 0.4; // 400ms de som
    const pause = 2.0; // 2 segundos de pausa (padrão telefônico)
    const sampleRate = ctx.sampleRate;
    
    const playTone = () => {
      const frameCount = sampleRate * duration;
      const buffer = ctx.createBuffer(1, frameCount, sampleRate);
      const channelData = buffer.getChannelData(0);
      
      for (let i = 0; i < frameCount; i++) {
        const t = i / sampleRate;
        channelData[i] = Math.sin(2 * Math.PI * ringFrequency * t) * 0.3;
      }
      
      const source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
      source.stop(ctx.currentTime + duration);
    };
    
    // Tocar imediatamente
    playTone();
    
    // Repetir a cada 2.4 segundos (0.4s de som + 2.0s de pausa) - padrão telefônico
    ringtoneInterval = setInterval(playTone, (duration + pause) * 1000);
  } catch (error) {
    console.error('Erro ao tocar ringtone:', error);
  }
};

export const stopRingtone = () => {
  if (ringtoneInterval) {
    clearInterval(ringtoneInterval);
    ringtoneInterval = null;
  }
  if (ringtoneAudio) {
    ringtoneAudio.pause();
    ringtoneAudio = null;
  }
};

